import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartComponent } from './start/start.component';
import { FolderComponent } from './main-ui/folder/folder.component';
import { LoginGuardService } from './core/services/login-guard.service';
import { AlbumComponent } from './main-ui/album/album.component';
import { PhotosComponent } from './main-ui/photos/photos.component';
import { DocCenterComponent } from './main-ui/doc-center/doc-center.component';

const appRoutes: Routes = [
    { path: '', pathMatch: 'full', component: StartComponent },
    { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
    { path: 'folder', component: FolderComponent, canActivate: [ LoginGuardService ] },
    { path: 'folder/:id', component: FolderComponent, canActivate: [ LoginGuardService ] },
    { path: 'album/:id', component: AlbumComponent, canActivate: [ LoginGuardService ] },
    { path: 'album/:id/:index', component: AlbumComponent, canActivate: [ LoginGuardService ] },
    { path: 'photos/:id/:index', component: PhotosComponent, canActivate: [ LoginGuardService ] },
    { path: 'doc-center/:id', component: DocCenterComponent, canActivate: [ LoginGuardService ] },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {})
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {}
